export default [
  {
    path: "/requests",
    name: "requests",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Заявки",
      permissions: ["application:index"],
    },
  },
  {
    path: "/requests/new",
    name: "request-create",
    component: () => import("./pages/create.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Создание заявки",
      permissions: ["application:store_dispatch", "application:store_dispatchless"],
    },
  },
  {
    path: "/requests/edit/:id",
    name: "request-edit",
    component: () => import("./pages/create.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Редактирование заявки",
      permissions: ["application:update"],
    },
  },
  {
    path: "/requests/:id",
    name: "request-open",
    component: () => import("./pages/open.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Просмотр заявки",
      permissions: ["application:show"],
    },
  },
  {
    path: "/returns",
    name: "returns",
    component: () => import("./pages/returns.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Возвраты остатков",
      permissions: ["application:return_index"],
    },
  },
];
